<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            <strong> Modification de la durée de retrait</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="gerant">Durée de retrait</label>
              <b-form-input type="number" v-model="delais.nb_jour" placeholder="Durée"></b-form-input>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="can('delaisretrait-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <span><b-button type="reset" size="sm" variant="danger" @click="goBack"><i class="fa fa-ban"></i> Annuler </b-button></span>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>
import api from '../../../api/';
export default {
  name: 'tables',
  props:{
    id:Number
  },
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      delais:{
            nb_jour: '',
            id:'',
            _method:'PUT'
      }
    }
  },
  methods:{
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    goBack() {
      this.$router.go(-1)
    },
    async put(){  
        // let response = await api.entity.get_balance_entites(token)
        // this.entite_id = response.data.data.id  
        //console.log(this.delais)
        this.response = await this.$store.dispatch('plafonds/put_delais',{id:this.delais.id,delais:this.delais})
        this.showAlert()
    },
    async displayDuree(){
        let response = await this.$store.dispatch('plafonds/get_delais')
        this.delais.nb_jour = response.data.nb_jour 
        this.delais.id = response.data.id 
    },
    async get_all_typesentite(){
      await this.$store.dispatch('entity/get_all_typesentite').then(()=>{
        store.getters['entity/types'].forEach(element => {
          this.options.push({
            value:element.libelle,
            text:element.libelle.toUpperCase()
          })
        });
      })
    },
    reset(){
            this.delais.nb_jour= ''
    },
    can(perm){
        return store.getters['auth/can'](perm)
    }
  },
  mounted(){
    this.displayDuree()
    //this.get_all_typesentite()
  }
}
</script>
